import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { UPLOAD_PANE_WIDTH_CLASSNAME } from "~/constants/WorkspaceSpacing";
export const PaneContainer = (param)=>{
    let { className, style, ...rest } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: classNames("rounded-md bg-surface-1 shadow-[0px_1px_3px_0px_#00000026,0px_0px_2px_0px_#00000040,0px_2px_8px_0px_#00000033]", UPLOAD_PANE_WIDTH_CLASSNAME, className),
        style: {
            ...style,
            maxWidth: "object" === "undefined" ? 0 : window.innerWidth - 32
        },
        ...rest
    });
};
